import { render } from "./ViewOrder.vue?vue&type=template&id=7a5e050e"
import script from "./ViewOrder.vue?vue&type=script&lang=js"
export * from "./ViewOrder.vue?vue&type=script&lang=js"

import "./ViewOrder.vue?vue&type=style&index=0&id=7a5e050e&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/orders/ViewOrder.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7a5e050e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7a5e050e', __exports__)) {
    console.log('reload')
    api.reload('7a5e050e', __exports__)
  }
  
  module.hot.accept("./ViewOrder.vue?vue&type=template&id=7a5e050e", () => {
    console.log('re-render')
    api.rerender('7a5e050e', render)
  })

}


export default __exports__